// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-panel_default__2d0ib"};